export default "/images/icon-time-small.svg?37a39db1ee80cd4ac52d0d1e22141932";